import { Grid, styled } from "@mui/material";
import React from "react";
import { TIPOS_MENSAJES } from "../../Constants";
import DoneAllIcon from '@mui/icons-material/DoneAll';

const MessageBubble = styled('div')(({ sent }) => ({
  backgroundColor: sent ? '#dcf8c6' : '#fff',
  color: '#303030',
  padding: '6px 7px 8px 9px',
  borderRadius: '7.5px',
  maxWidth: '65%',
  position: 'relative',
  boxShadow: '0 1px 0.5px rgba(0,0,0,0.13)',
  marginBottom: '10px',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    width: 0,
    height: 0,
    border: '10px solid transparent',
    ...(sent ? {
      right: '-10px',
      borderLeftColor: '#dcf8c6',
      borderRight: 0,
      borderTop: 0,
    } : {
      left: '-10px',
      borderRightColor: '#fff',
      borderLeft: 0,
      borderTop: 0,
    }),
  }
}));

const MessageText = styled('p')({
  margin: 0,
  fontSize: '14.2px',
  lineHeight: '19px',
  whiteSpace: 'pre-wrap',
  wordWrap: 'break-word',
});

const MessageMeta = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  marginTop: '4px',
  float: 'right',
});

const MessageTime = styled('span')({
  fontSize: '11px',
  color: 'rgba(0,0,0,0.45)',
  marginLeft: '4px',
});

const MessageTick = styled(DoneAllIcon)({
  fontSize: '16px',
  color: '#53bdeb',
});

export default function Texto({texto, tipos, times}) {
  const isSent = tipos === TIPOS_MENSAJES.enviado;
  
  return (
    <Grid 
      container 
      justifyContent={isSent ? 'flex-end' : 'flex-start'}
      sx={{ padding: '0 5%' }}
    >
      <MessageBubble sent={isSent}>
        <MessageText>{texto}</MessageText>
        <MessageMeta>
          <MessageTime>{times}</MessageTime>
          {isSent && <MessageTick />}
        </MessageMeta>
      </MessageBubble>
    </Grid>
  );
} 